import script from "./orderDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./orderDialog.vue?vue&type=script&setup=true&lang=js"

import "./orderDialog.vue?vue&type=style&index=0&id=37edc9f6&lang=css"
import "./orderDialog.vue?vue&type=style&index=1&id=37edc9f6&lang=scss&scoped=true"

import exportComponent from "/Users/a1234/Documents/vue/vue3/demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37edc9f6"]])

export default __exports__